module.exports = __webpack_public_path__ + "static/19-ea3f861a7518bc83e35cf4f7a4ff2e09.jpg";